"use client";

import React from 'react';
import { Download } from 'lucide-react';
import { CharcoalStar, CharcoalUnderline } from './Decorative';
import { useTranslations } from 'next-intl';
import { useDownload } from '@/hooks/useDownload';

const keyPrefix = "playbook.macaronApp";

const downloadSource = "macaron-app";

const messageKey = {
  appName: `${keyPrefix}.appName`,
  worldFirstPersonalAiAgent: `${keyPrefix}.worldFirstPersonalAiAgent`,
  helpsYouLiveBetterNotJustWorkHarder: `${keyPrefix}.helpsYouLiveBetterNotJustWorkHarder`,
  downloadForIos: `${keyPrefix}.downloadForIos`,
  downloadForAndroid: `${keyPrefix}.downloadForAndroid`,
}

const Hero: React.FC = () => {
  const t = useTranslations();
  const { handleAppStoreClick, handleAndroidDownloadClick } = useDownload({ downloadSource });

  return (
    <section className="relative pt-32 pb-16 px-6 max-w-4xl mx-auto flex flex-col items-center gap-8 text-center">
      {/* Decorative Elements */}
      <CharcoalStar className="absolute top-24 -left-8 w-12 h-12 rotate-[-15deg] hidden md:block" />

      <div className="relative inline-block">
        <h1 className="text-5xl md:text-7xl font-serif text-macaron-playbook-app-primary leading-tight tracking-tight">
          {t(messageKey.appName)}
        </h1>
        <CharcoalUnderline className="w-full h-4 mt-1 text-macaron-playbook-app-secondary" />
      </div>

      {/* Unified Lead/Subtitle size to text-xl */}
      <h2 className="text-xl text-macaron-playbook-app-secondary font-sans font-normal max-w-2xl leading-relaxed">
        {t(messageKey.worldFirstPersonalAiAgent)} <br className="hidden md:block" />
        {t(messageKey.helpsYouLiveBetterNotJustWorkHarder)}
      </h2>

      <div className="flex flex-col sm:flex-row gap-4 mt-4 w-full sm:w-auto justify-center">
        {/* Unified Button size to text-base */}
        <button onClick={handleAppStoreClick} className="flex items-center justify-center gap-3 bg-macaron-playbook-app-primary text-macaron-playbook-app-page hover:bg-macaron-playbook-app-dark transition-colors px-6 py-3 rounded-full font-sans font-medium text-base border border-transparent shadow-sm">
          <Download size={18} />
          <span>{t(messageKey.downloadForIos)}</span>
        </button>
        <button onClick={handleAndroidDownloadClick} className="flex items-center justify-center gap-3 bg-macaron-playbook-app-primary text-macaron-playbook-app-page hover:bg-macaron-playbook-app-dark transition-colors px-6 py-3 rounded-full font-sans font-medium text-base border border-transparent shadow-sm">
          <Download size={18} />
          <span>{t(messageKey.downloadForAndroid)}</span>
        </button>
      </div>
    </section>
  );
};

export default Hero;